<script setup lang="ts">
defineProps<{
    productBalance: number;
    formattedProductBalance?: string;
}>();
</script>

<template>
  <p>
    {{ formattedProductBalance }}
  </p>
</template>
